import(/* webpackMode: "eager" */ "/workspace/src/app/analysis/layout.tsx");
